import { render, staticRenderFns } from "./TourMessage.vue?vue&type=template&id=58496168&scoped=true&"
import script from "./TourMessage.vue?vue&type=script&lang=js&"
export * from "./TourMessage.vue?vue&type=script&lang=js&"
import style0 from "./TourMessage.vue?vue&type=style&index=0&id=58496168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58496168",
  null
  
)

export default component.exports